import { useState, useEffect } from 'react';

export const useDebounce = (value, delay) => {
  // Estado para armazenar o valor "debounced" (atrasado)
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // Configura um timer para atualizar o valor debounced após o delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // Limpa o timer se o valor mudar (ex: usuário continua digitando)
      // Isso garante que o efeito só rode após o usuário parar de digitar pelo tempo do delay.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Recria o timer apenas se o valor ou o delay mudarem
  );

  return debouncedValue;
};
